import React, { useEffect, useCallback } from 'react'
import { Provider, useSelector } from 'react-redux'
import { Route, BrowserRouter as Router, Routes, Navigate } from 'react-router-dom'
import { getTitleByPath } from '../common/helpers/getPageTitle'
import AuthSuccessPage from '../components/auth/AuthSuccessPage'
import LoginPage from '../components/LoginPage'
import DashboardApp from '../DashboardApp'
import InfoApp from '../InfoApp'
import PublicBugHunterStatisticsPage from '../components/statistics/PublicBugHunterStatisticsPage'
import PublicTimeTrackingPage from '../components/statistics/PublicTimeTrackingPage'
import { authRoutes, routes, publicRoutes } from '../setup/config'
import history from '../setup/history'
import { IGlobalState } from '../setup/reducers'
import store from '../setup/store'

const AppContent: React.FC = () => {
  const token = useSelector<IGlobalState, string>(state => state.token)
  
  // Check environment variables for authentication bypass
  const isDevelopment = process.env.REACT_APP_ENV === 'dev'
  const isAuthenticated = token || isDevelopment

  return (
    <Routes>
      <Route
        path={authRoutes.authSuccess}
        element={<AuthSuccessPage />}
      />
      <Route
        path={routes.login}
        element={<LoginPage />}
      />
      <Route
        path={publicRoutes.bugHunterStatistics}
        element={<PublicBugHunterStatisticsPage />}
      />
      <Route
        path={publicRoutes.timeTracking}
        element={<PublicTimeTrackingPage />}
      />
      <Route
        path={`${routes.dashboardPage}/*`}
        element={<DashboardApp />}
      />
      <Route
        path="/"
        element={
          isAuthenticated ? 
            <Navigate to="/app" replace /> : 
            <Navigate to="/login" replace />
        }
      />
      <Route
        path="/app"
        element={
          isAuthenticated ? 
            <Navigate to="/app/dashboard" replace /> : 
            <Navigate to="/login" replace />
        }
      />
      <Route
        path="*"
        element={<InfoApp />}
      />
    </Routes>
  )
}

const AppRouter: React.FC = () => {

  const updatePageTitle = useCallback((state?: IGlobalState) => {
    document.title = getTitleByPath(history.location.pathname, state)
  }, [])

  useEffect(() => {
    updatePageTitle()

    const unsubscribe = store.subscribe(() => {
      updatePageTitle(store.getState())
    })

    const unlisten = history.listen((location:any) => {
      updatePageTitle()
    })

    return () => {
      if (unlisten) {
        unlisten()
      }
      if (unsubscribe) {
        unsubscribe()
      }
    }
  }, [updatePageTitle])

  return (
    <Provider store={store}>
      <Router >
      {/* history={history}> */}
        <AppContent />
      </Router>
    </Provider>
  )
}

export default AppRouter
